import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { useSegmentPaths } from "../hooks/useSegmentPaths";

import { ROUTES } from "@/constants/routes";
import { useBreadcrumbs } from "@/lib/hooks/useBreadcrumbs";
import { useClients } from "@/lib/hooks/useClients";

type SegmentBreadcrumbsProps = {
  current: string;
};

function AdminSegmentBreadcrumbs({ current }: SegmentBreadcrumbsProps) {
  const { t } = useTranslation();
  const { clientId } = useParams();
  const { client } = useClients();
  const paths = useSegmentPaths();

  return useBreadcrumbs({
    items: [
      { label: t("common.clients"), href: `/${ROUTES.clients}` },
      { label: client?.name ?? t("common.client"), href: `/${ROUTES.clients}/${clientId}` },
      { label: t("common.segments"), href: paths.overview },
      { label: current },
    ],
  });
}

function ManagerSegmentBreadcrumbs({ current }: SegmentBreadcrumbsProps) {
  const { t } = useTranslation();
  const paths = useSegmentPaths();

  return useBreadcrumbs({
    items: [{ label: t("common.segments"), href: paths.overview }, { label: current }],
  });
}

export function SegmentBreadcrumbs(props: SegmentBreadcrumbsProps) {
  const { clientId } = useParams();

  if (clientId) return <AdminSegmentBreadcrumbs {...props} />;
  return <ManagerSegmentBreadcrumbs {...props} />;
}
